// removed by extract-text-webpack-plugin
module.exports = {"delectableRatingBadge":"_2TwMi","best":"_2Vhig","rating":"_2YYjI","good":"_1SNzs","ok":"_2tN84","bad":"_3eS3l","message":"_11ekp"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/DelectableRating/index.sass
// module id = 814
// module chunks = 0 1